import { SkeletonBar } from '../../skeletons/SkeletonBar';

export const ToolbarLoadingSkeleton = () => {
  return (
    <div className="flex flex-row w-full gap-x-3 justify-end">
      <SkeletonBar height="h-10" className="my-1" />
    </div>
  );
};
